import { Moment } from '@chipinside/frontend'
import { Translate } from '@chipinside/translate'
import { isArray, isNil, isObject, uniqueId } from 'lodash'
import React from 'react'

import BooleanBadge from '#/components/badges/BooleanBadge'
import BirthInfo from '#/components/EventInfos/Birth'
import { allow_list, AllowList } from '#/components/FormatCell/Types/Infos/allowList'
import SegmentedInfoList from '#/components/SegmentedInfoList'

type Response = {
  label?: string
  value: React.ReactNode
}

const getField = (key: AllowList, value: any) => {
  let response = { label: undefined, value } as Response

  switch (key) {
    // TODO ALTERAR NOS OUTROS LOCAIS (BACKEND)
    case 'heat_signs':
    case 'signals_and_symptoms':
      response.label = Translate({ messageKey: 'signals_and_symptoms' })
      response.value =
        isArray(value) && value?.length ? (
          <ul style={{ margin: '5px 0' }}>
            {value?.map(({ text }) => (
              <li key={uniqueId(text)}>{text}</li>
            ))}
          </ul>
        ) : null
      break

    // TODO VERIFICAR COM O BACKEND USAR PADRÃO {status, text}
    // Parece igual, porem não é, aqui o value é um array de strings
    case 'heat_signs_text':
      response.label = Translate({ messageKey: 'signals_and_symptoms' })
      response.value =
        isArray(value) && value?.length ? (
          <ul style={{ margin: '5px 0' }}>
            {value?.map(text => (
              <li key={uniqueId(text)}>{text}</li>
            ))}
          </ul>
        ) : null
      break

    case 'mammary_quarter':
      response.label = Translate({ messageKey: 'mammary_quarter' })
      response.value = value?.length ? (
        <ul style={{ margin: '5px 0' }}>
          {value?.map(({ text }) => (
            <li key={uniqueId(text)}>{text}</li>
          ))}
        </ul>
      ) : null
      break

    case 'contract_first_payment':
      response.label = Translate({ messageKey: 'contract_first_payment' })
      response.value = value ? Moment(value).format('L') : null
      break

    case 'designer.name':
      response.label = Translate({ messageKey: 'designed_by' })
      break

    case 'cancellation_motive_text':
    case 'cancellation_reason':
      response.label = Translate({ messageKey: 'cancellation_reason' })
      break

    case 'installed_by':
      response.label = Translate({ messageKey: 'installed_by' })
      break

    case 'fidelity':
      response.label = Translate({ messageKey: 'fidelity' })
      break

    case 'body_score':
      response.label = Translate({ messageKey: 'body_score' })
      break

    case 'term_of_contract':
      response.label = Translate({ messageKey: 'term_of_contract' })
      break

    case 'financing_modality':
      response.label = Translate({ messageKey: 'financing_modality' })
      response.value = value?.financing_modality?.text ?? value?.text
      break

    case 'order_date':
      response.label = Translate({ messageKey: 'order_date' })
      response.value = value ? Moment.view(value) : null
      break

    case 'register':
      response.label = Translate({ messageKey: 'national_register' })
      response.value = value ?? Translate({ messageKey: 'without_information' })
      break

    case 'international_register':
      response.label = Translate({ messageKey: 'international_register' })
      break

    case 'analysis.lactose_percentage':
      response.label = Translate({ messageKey: 'lactose_percentage' })
      break

    case 'analysis.solid_percentage':
      response.label = Translate({ messageKey: 'solid_percentage' })
      break

    case 'analysis.urea':
      response.label = Translate({ messageKey: 'urea' })
      break

    case 'milkings.milking_0':
      response.label = Translate({ messageKey: 'milking_item', params: { item: 1 } })
      break

    case 'milkings.milking_1':
      response.label = Translate({ messageKey: 'milking_item', params: { item: 2 } })
      break

    case 'milkings.milking_2':
      response.label = Translate({ messageKey: 'milking_item', params: { item: 3 } })
      break

    case 'milkings.milking_3':
      response.label = Translate({ messageKey: 'milking_item', params: { item: 4 } })
      break

    case 'negotiated_condition':
      response.label = Translate({ messageKey: 'negotiated_condition' })
      break
    case 'dosage':
      response.label = Translate({ messageKey: 'how_to_use' })
      break

    case 'reason_text':
      response.label = Translate({ messageKey: 'reason_text' })
      response.value = value
      break
    case 'responsible.name':
      response.label = Translate({ messageKey: 'responsible' })
      break

    case 'departure_reason':
      response.label = Translate({ messageKey: 'departure_reason' })
      response.value = value?.text
      break

    case 'death_method':
      response.label = Translate({ messageKey: 'death_method' })
      response.value = value?.text
      break

    case 'death_reason':
      response.label = Translate({ messageKey: 'discard_reason' })
      response.value = value?.text
      break

    case 'death_method_text':
      response.label = Translate({ messageKey: 'death_method' })
      break

    case 'death_reason_text':
      response.label = Translate({ messageKey: 'discard_reason' })
      break

    case 'dry_reason':
      response.label = Translate({ messageKey: 'dry_reason' })
      response.value = value?.text
      break

    case 'departure_kind':
      response.label = Translate({ messageKey: 'departure_kind' })
      response.value = value?.text
      break

    case 'mastitis_causative_agent':
      response.label = Translate({ messageKey: 'mastitis_causative_agent' })
      response.value = value?.text
      break

    case 'mastitis_intensity_level':
      response.label = Translate({ messageKey: 'mastitis_intensity_level' })
      response.value = value?.text
      break

    case 'answered_at':
      response.label = Translate({ messageKey: 'answered_at' })
      response.value = value ? Moment(value).format('L') : null
      break

    case 'device_renewal':
      response.label = Translate({ messageKey: 'device_renewal' })
      response.value = value?.text
      break

    case 'comment':
    case 'comments':
    case 'moderation_comment':
    case 'relevant_event_comment':
    case 'observation':
    case 'extra':
      response.label = Translate({ messageKey: 'comment_plural' })
      break

    case 'relevant_event_timestamp':
      response.label = Translate({ messageKey: 'latest_evaluation' })
      response.value = value ? Moment(value).format('L LT') : null
      break

    case 'ppi_status':
      response.label = 'PPI'
      response.value = !isNil(value) && isObject(value) ? (value as any)?.text : value
      break

    case 'condition':
      response.label = Translate({ messageKey: 'animal_condition_today' })
      response.value = value ? Translate({ messageKey: value }) : null //REVISAR
      break

    case 'diagnostic.name_text':
    case 'diagnostic':
      response.label = Translate({ messageKey: 'diagnostic' })
      break

    case 'treated':
      response.label = Translate({ messageKey: 'treated_male' })
      response.value = Translate({ messageKey: value ? 'yes' : 'no' })
      break

    case 'treatment':
      response.label = Translate({ messageKey: 'used_treatment' })
      break

    case 'treatments':
      response.label = Translate({ messageKey: 'treatment_plural' })

      if (Array.isArray(value)) {
        response.value = value?.length ? (
          <ul style={{ margin: '5px 0' }}>
            {value?.map(({ name }) => (
              <li key={uniqueId(name)}>{name}</li>
            ))}
          </ul>
        ) : null
      }
      break

    case 'donor':
      response.label = Translate({ messageKey: 'donor' })
      break

    case 'health_completion_type':
      response.label = Translate({ messageKey: 'closure_by' })
      break

    case 'semen':
      response.label = Translate({ messageKey: 'semen_type' })
      response.value = value?.semen_type_text
        ? Translate({ messageKey: value.semen_type_text })
        : null
      break

    case 'semen.label':
    case 'semen_label':
      response.label = Translate({ messageKey: 'bull_or_semen' })
      break

    case 'with_anormal_behavior':
    case 'abnormal_behaviour':
      response.label = Translate({
        messageKey: 'did_the_animal_exhibit_any_abnormal_behavior',
      })
      response.value = value ? <BooleanBadge onlyText value={value} /> : null
      break

    case 'gender':
      response.label = Translate({ messageKey: 'animal_gender' })
      response.value = value ? Translate({ messageKey: value }) : null
      break

    case 'complication':
      response.label = Translate({ messageKey: 'calvin_complication' })
      response.value = value ? <BooleanBadge onlyText value={value} /> : null
      break

    case 'calf_status':
      response.label = Translate({ messageKey: 'calf_condition' })
      response.value = value ? Translate({ messageKey: value }) : null //REVISAR
      break

    case 'embryo_type_text':
      response.label = Translate({ messageKey: 'embryo_type' })
      response.value = value ? Translate({ messageKey: value }) : null
      break

    case 'semen_type_text':
      response.label = Translate({ messageKey: 'semen_type' })
      response.value = value ? Translate({ messageKey: value }) : null
      break

    case 'from_algorithm':
      response.label = Translate({ messageKey: 'automatically_detected' })
      response.value = value ? <BooleanBadge onlyText value={value} /> : null
      break

    case 'with_ftai':
      response.label = Translate({ messageKey: 'heat_type_iatf' })
      response.value = value ? <BooleanBadge onlyText value={value} /> : null
      break

    case 'with_heat':
      response.label = Translate({
        messageKey: 'heat_register_12_hours_before',
      })
      response.value = value ? <BooleanBadge onlyText value={value} /> : null
      break

    case 'birth_events':
      response.value = BirthInfo({ birthInfos: value })
      break

    // TODO VERIFICAR COM O BACKEND USAR PADRÃO {status, text}
    case 'method_text':
    case 'heat_detection_method_text':
      response.label = Translate({ messageKey: 'detection_method' })
      break

    case 'heat_intensity_text':
      response.label = Translate({ messageKey: 'intensity' })
      break

    case 'heat_intensity':
      response.label = Translate({ messageKey: 'intensity' })
      response.value = value?.text
      break

    case 'heat_detection_method':
      response.label = Translate({ messageKey: 'detection_method' })
      response.value = value?.text
      break

    case 'description':
      response.label = Translate({ messageKey: 'description' })
      break

    case 'confirmed_at':
      response.label = Translate({ messageKey: 'confirmed_at' })
      response.value = value ? Moment.view(value) : null
      break

    case 'deleted_at':
      response.label = Translate({ messageKey: 'deleted_at' })
      response.value = value ? Moment.view(value) : null
      break

    case 'recommendation':
      response.label = Translate({ messageKey: 'recommendation' })
      break

    case 'restored':
      response.label = Translate({ messageKey: 'recovered_event' })
      response.value = value ? <BooleanBadge onlyText value={value} /> : null
      break

    case 'created_item_at':
    case 'created_at':
      response.label = Translate({ messageKey: 'created_item_at' })
      response.value = value ? Moment.view(value) : null
      break

    case 'updated_at':
      response.label = Translate({ messageKey: 'updated_at' })
      response.value = value ? Moment.view(value) : null
      break

    case 'detected_at':
      response.label = Translate({ messageKey: 'detected_at' })
      response.value = value ? Moment.view(value) : null
      break

    case 'received_at':
      response.label = Translate({
        messageKey: 'collar_event_received_at',
      })
      response.value = value ? Moment.view(value) : null
      break

    case 'processed_at':
      response.label = Translate({ messageKey: 'processed_at' })
      response.value = value ? Moment.view(value) : null
      break

    case 'last_processed_at':
      response.label = Translate({ messageKey: 'last_processed_at' })
      response.value = value ? Moment.view(value) : '-'
      break

    case 'user.name':
    case 'creator.name':
    case 'creator_name':
      response.label = Translate({ messageKey: 'registered_by' })
      break

    case 'confirmer.name':
    case 'confirmer_name':
      response.label = Translate({ messageKey: 'confirmed_by' })
      break

    case 'inseminator_name':
    case 'inseminator.name':
      response.label = Translate({ messageKey: 'inseminator' })
      break

    case 'milking_return':
      response.label = Translate({
        messageKey: 'end_of_item_withdrawal',
        params: {
          item: Translate({ lower: true, messageKey: 'milk' }),
        },
      })
      response.value = value ? Moment.view(value) : null
      break

    case 'meat_return':
      response.label = Translate({
        messageKey: 'end_of_item_withdrawal',
        params: {
          item: Translate({ lower: true, messageKey: 'meat' }),
        },
      })
      response.value = value ? Moment.view(value) : null
      break

    case 'calving_procedure':
      response.label = Translate({ messageKey: 'calving_dificulty' })

      switch (value) {
        case 'normal':
          response.value = Translate({ messageKey: 'normal' })
          break

        case 'intervention':
          response.value = Translate({ messageKey: 'easy_unassisted' })
          break

        case 'mechanical-traction':
          response.value = Translate({ messageKey: 'difficult_assistance' })
          break

        case 'veterinary-care':
          response.value = Translate({ messageKey: 'difficult_vet_care' })
          break

        case 'cirurgical-procedure':
          response.value = Translate({ messageKey: 'caesarean_surgery' })
          break

        default:
          response.value = null
          break
      }
      break

    case 'handling':
      response.value = value ? <SegmentedInfoList data={value} isInfo /> : null
      break

    // foetus_text: [Fêmea, Macho, Macho]
    case 'foetus_text':
      response.label = Translate({ messageKey: 'foetus' })
      response.value = value?.join(', ')
      break

    case 'clinical_opinion_text':
      response.label = Translate({ messageKey: 'clinical_opinion' })
      response.value = value?.join(', ')
      break

    case 'penultimate_event_clinical_opinion':
      response.label = Translate({ messageKey: 'previous_clinical_opinion' })
      break

    case 'penultimate_event_comment':
      response.label = Translate({ messageKey: 'previous_comment' })
      break

    case 'farm_new_semen.name':
      response.label = Translate({ messageKey: 'linked_to_farm_bull' })
      break

    // cow.gender: male, female
    // cow.calf_status: normal, premature, stillbirth
    case 'calves':
      response.label = Translate({ messageKey: 'son_plural' })
      response.value = value
        ?.map(cow => {
          const status =
            cow?.calf_status && typeof cow.calf_status === 'string'
              ? Translate({ messageKey: cow.calf_status })
              : ''

          const gender = cow.gender
            ? Translate({ messageKey: cow.gender })
            : Translate({ messageKey: 'calf_unknown' })

          return `${gender} ${status}`
        })
        .join(', ')
      break

    default: //nothing to moo
  }

  return response
}

const getItems = (data: Record<AllowList, any>) => {
  return Object.entries(data)
    .filter(([key]) => allow_list.includes(key as AllowList))
    .map(([key, value]) => ({ ...getField(key as AllowList, value), key }))
}

export { getItems }
